/**
 * @generated SignedSource<<da12abafadbeeeb286bba016228ab38c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type relatedWorkHeading_versionProgress$data = ReadonlyArray<{
  readonly node: {
    readonly __typename: "JiraVersionRelatedWorkConfluenceReleaseNotes";
    readonly url: AGG$URL | null | undefined;
  } | {
    readonly __typename: "JiraVersionRelatedWorkGenericLink";
    readonly url: AGG$URL | null | undefined;
  } | {
    readonly __typename: "JiraVersionRelatedWorkNativeReleaseNotes";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "relatedWorkHeading_versionProgress";
} | null | undefined>;
export type relatedWorkHeading_versionProgress$key = ReadonlyArray<{
  readonly " $data"?: relatedWorkHeading_versionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"relatedWorkHeading_versionProgress">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "name": "url"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "relatedWorkHeading_versionProgress",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "JiraVersionRelatedWorkGenericLink"
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/)
            ],
            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
          }
        ]
      },
      "action": "NONE",
      "path": "node"
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};
})();

(node as any).hash = "211a6665d1a1915d987787889e12cca6";

export default node;
